import React from 'react'
// import React, { useState, useEffect } from "react";
// import Container from 'react-bootstrap/Container';

import logoGrey from '../images/ComponentImg/Logo/logo-grey.png'
import { Link } from "react-router-dom";
import './Footer.css'

function Footer() {
  return (
    <div className="Footer">
      <div className="Footer-logo-section">
        <img src={logoGrey} width="200px" height="200px" alt="logo"></img>
        <p>All contents of this site cannot be used without permission.</p>
      </div>

      <div className="FooterContact">
        <h2>Contact</h2>
        <p>DongGuang City, GuangDong Province, China<br></br>
          GuangDong, China<br></br>
          +(86)769-000-0000<br></br>
          info@hlztouch.com
          {/* info@jnfreight.tn */}
        </p>
      </div>

      <div className="FooterLinks">
        <h2>Site Links</h2>
        {/* <h2>Liens Utiles</h2> */}
        <Link to="/" className="FooterLink">+ HLZ Technology</Link>
        <Link to="/ProductTouch" className="FooterLink">+ Products</Link>
        <Link to="/ServiceMarket" className="FooterLink">+ Services</Link>
        <Link to="/SupportTouch" className="FooterLink">+ Supports</Link>
        <Link to="/AboutUs" className="FooterLink">+ AboutUs</Link>
        <Link to="/ContactUs" className="FooterLink">+ ContactUs</Link>
      </div>
    </div>
  );
}

export default Footer;

  // const [showTopBtn, setShowTopBtn] = useState(false);
  // useEffect(() => {
  //   window.addEventListener("scroll", () => {
  //     if (window.scrollY > 1000) { setShowTopBtn(true); }
  //     else { setShowTopBtn(false); }
  //   });
  // }, []);

  // function goTop() {
  //   window.scrollTo({  top: 0,  behavior: "smooth", });
  // }